export const eme = {
  methods: {
    //TODO：查询全部物资分类
    async geteMergencyTree() {
      let res = await this.$http.get("/tenant/emergency/type/list");
      return res;
    },

    //TODO： 新增类型
    async addMergencyType(obj) {
      let res = await this.$http.post("/tenant/emergency/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO： 修改类型
    async upMergencyType(obj) {
      let res = await this.$http.put("/tenant/emergency/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO： 删除类型
    async delMergencyType(id) {
      let res = await this.$http.delete(`/tenant/emergency/type/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO：点击树形查询物资
    async getQuestionMergency(params) {
      let { pageNum, pageSize, typeId, belong, title } = params;
      let res = await this.$http.get("/tenant/emergency/list", {
        title: title,
        belong: belong ?? null,
        typeId: typeId == 0 ? null : typeId,
        pageNum,
        pageSize,
      });
      return res;
    },

    //TODO: 新增物资
    async addQuestion(obj) {
      let res = await this.$http.post("/tenant/emergency", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 批量生成物资
    async addPLQuestion(obj) {
      let res = await this.$http.post("/tenant/emergency/generate/batch", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 获取物资详情
    async getQuestionInfo(id) {
      let res = await this.$http.get(`/tenant/emergency/${id}`);
      return res;
    },
    //TODO: 获取物资详情列表
    async getQuestionDetail(obj) {
      let { pageNum, pageSize, id,name,fixUserName,status } = obj;
      let res = await this.$http.get(`/tenant/emergency/option/list`, {
        fixUserName:fixUserName ?? null,
        status:status ?? null,
        name:name ?? null,
        id: id ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },

    //TODO：通过物资ID查询维护信息列表
    async getMaintainData(obj) {
      let { pageNum, pageSize, id ,name ,fixTime } = obj;
      let res = await this.$http.get(`/tenant/emergency/fix/list`, {
        emergencyInfoId:id ?? null,
        name:name ?? null,
        fixTime:fixTime ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },
    //TODO：修改物资详细列表中的数据
    async upQuestionDetailItems(obj) {
      let res = await this.$http.put("/tenant/emergency/option/edit", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    
    //TODO： 删除物资详细列表中的数据
    async delQuestionDetailItems(id) {
      let res = await this.$http.delete(`/tenant/emergency/option/del?id=${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：批量生成二维码
    async getQuestionPL(arr) {
      let res = await this.$http.post(`/tenant/emergency/generate/qrcode`, arr);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 修改物资
    async upQuestion(obj) {
      let res = await this.$http.put("/tenant/emergency", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除物资
    async delQuestion(id) {
      let res = await this.$http.delete(`/tenant/emergency/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:上传物资图片
    async uploadQuestionImages(fetchForm) {
      let res = await this.$http.post(`/tenant/file/emergency`, fetchForm, {
        "Content-Type": "multipart/form-data",
      });
    },
    //TODO: 删除物资图片
    async delQuestionImages(obj) {
      let res = await this.$http.delete("/tenant/file/delete/photo", {
        id: obj.id,
        emergencyId: obj.emergencyId,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }

      return res;
    },

    //TODO： 根据列表id 获取全部二维码
    async getQuestionImages(id) {
      let res = await this.$http.get(`/tenant/emergency/qrcode/${id}`);
      return res;
    },

    //TODO： 根据列表id 生成二维码
    async getGQRuestion(id, num) {
      let res = await this.$http.post(`/tenant/emergency/generate/qrcode`, {
        id: id,
        num: num,
      });

      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 获取出入库记录
    async getInsertorOutRecord(obj) {
      let { pageNum, pageSize, qrcodeId, type,name } = obj;
      let res = await this.$http.get("/tenant/emergency/history", {
        name: name ?? null,
        type: type ?? null,
        qrcodeId: qrcodeId ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },

    //TODO: 应急预案题目场景列表
    async getQuestionSceneList() {
      let res = await this.$http.get(`/tenant/emergency/plan/scene/list`);
      return res;
    },

    //TODO: 新增场景
    async addQuestionScene(obj) {
      let res = await this.$http.post("/tenant/emergency/plan/scene", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改场景
    async editQuestionScene(obj) {
      let res = await this.$http.put("/tenant/emergency/plan/scene", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 删除场景
    async deleteQuestionScene(id) {
      let res = await this.$http.delete(`/tenant/emergency/plan/scene/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:根据场景查询题目
    async getQuestionListBySceneId(params) {
      let { pageNum, pageSize, parentId } = params;
      let res = await this.$http.get("/tenant/emergency/plan/list", {
        parentId: parentId == 0 ? null : parentId,
        pageNum,
        pageSize,
      });
      return res;
    },
    //TODO: 根据场景获取全部题目
    async getQuestionListBySceneIdAll(id) {
      let res = await this.$http.get(`/tenant/emergency/plan/list/${id}`);
      return res;
    },
    //TODO：新增场景题目
    async addSceneQuestion(obj) {
      let res = await this.$http.post("/tenant/emergency/plan", obj);

      return res;
    },
    //TODO：新增场景题目
    async UpSceneQuestion(obj) {
      let res = await this.$http.put("/tenant/emergency/plan", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 删除场景题目
    async deleteQuestion(id) {
      let res = await this.$http.delete(`/tenant/emergency/plan/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 上传场景图片
    async uploadSceneImg(base64, id) {
      let file = await this.$format.dataURLtoFile(
        base64,
        new Date().getTime() + ".png"
      );
      let formData = new FormData();
      formData.append("id", id);
      formData.append("file", file, new Date().getTime() + ".jpg");
      let respon = await this.$http.post(
        `/tenant/file/emergency/topic`,
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );
      if (respon.code == 200)
        this.$message({ message: respon.msg, type: "success" });
      else this.$message({ message: respon.msg, type: "error" });
    },
    //TODO: 提交答案
    async submitAnswer(obj) {
      let res = await this.$http.post(`/tenant/emergency/plan/submit`, obj);

      return res;
    },

    //查询全部物资，不分页
    async getAllPagesQuestion() {
      let res = await this.$http.get(`/tenant/emergency/all/list`);
      return res;
    },
  },
};
